export default "__VITE_ASSET__CTy$PHq8__"